import React from 'react'
import Link from 'next/link'
import Image from 'next/image'
import { Badge } from '@components/ui/badge'
import { ArrowRight } from 'lucide-react'
import { motion } from 'framer-motion'

const ExploreMegaMenu = ({ item }) => {
  return (
    <>
      <div
        className={`grid ${
          item.sections.length === 1
            ? 'grid-cols-1'
            : item.sections.length === 2
              ? 'grid-cols-1 md:grid-cols-2'
              : 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3'
        }`}
      >
        {item.sections.map((section, sectionIndex) => (
          <motion.div
            key={`section-${sectionIndex}`}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.2, delay: 0.1 * sectionIndex }}
            className={`p-5 lg:p-6 ${
              sectionIndex < item.sections.length - 1 ? 'border-b md:border-b-0 md:border-r border-theme-border' : ''
            } ${section.background ? section.background : ''}`}
          >
            <h3 className="font-semibold text-sm mb-3 text-theme-primary tracking-wider">{section.title}</h3>
            <div className="space-y-3.5">
              {section.links &&
                section.links.map((link, linkIndex) => (
                  <motion.div
                    key={`link-${sectionIndex}-${linkIndex}`}
                    initial={{ opacity: 0, x: -10 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.2, delay: 0.1 + linkIndex * 0.05 }}
                  >
                    <Link
                      href={link.href || '#'}
                      className="group/item flex gap-3 items-start hover:bg-gray-50 rounded-md p-1.5 -ml-1.5 transition-colors duration-150"
                    >
                      <div className="min-w-10 min-h-10">{link.iconContent && link.iconContent}</div>
                      <div className="flex flex-col gap-2">
                        <div className="flex items-center gap-2">
                          <h4 className="font-medium">{link.label}</h4>
                          {link.badge && <Badge className={link.badgeClassName}>{link.badge}</Badge>}
                        </div>
                        {link.description && (
                          <div className="text-sm text-gray-600 line-clamp-2">{link.description}</div>
                        )}
                      </div>
                    </Link>
                  </motion.div>
                ))}
            </div>

            {/* Featured items */}
            {section.featuredImage && (
              <motion.div
                className="group relative rounded-lg border overflow-hidden"
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.3, delay: 0.2 + sectionIndex * 0.1 }}
              >
                <div className="relative h-32 overflow-hidden">
                  <Image
                    src={section.featuredImage.src}
                    alt={section.featuredImage.alt}
                    width={400}
                    height={200}
                    placeholder="blur"
                    blurDataURL="/assets/images/placeholder.png"
                    className="h-full w-full object-cover"
                  />
                </div>
                <div className="p-4">
                  <div className="flex absolute top-0 right-0 items-center justify-between mb-1">
                    <h4 className="font-medium">{section.featuredImage.title}</h4>
                    {section.featuredImage.badge && (
                      <Badge className={section.featuredImage.badgeClassName}>{section.featuredImage.badge}</Badge>
                    )}
                  </div>
                  <p className="text-sm text-gray-600">{section.featuredImage.description}</p>
                </div>
              </motion.div>
            )}
          </motion.div>
        ))}
      </div>

      {/* Footer */}
      {item.footer && (
        <motion.div
          className="bg-gray-50 border-t border-theme-border p-3 flex flex-col sm:flex-row justify-between items-center"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.2, delay: 0.3 }}
        >
          <span className="text-sm text-theme-text-muted">
            <span className="text-gray-700 "> {item.footer.text} </span>
            <Link
              href={item.footer.linkHref}
              className=" text-sm font-medium text-blue-600 inline-flex items-center hover:underline mt-2 sm:mt-0"
            >
              {item.footer.linkText}
            </Link>
          </span>
          <motion.div whileHover={{ x: 3 }} transition={{ duration: 0.2 }}>
            <Link
              href={item.footer.viewAllHref}
              className="text-sm font-medium text-blue-600 flex items-center hover:underline mt-2 sm:mt-0"
            >
              {item.footer.viewAllText} <ArrowRight className="w-3 h-3 ml-1" />
            </Link>
          </motion.div>
        </motion.div>
      )}
    </>
  )
}

export default ExploreMegaMenu
